/**
 *  © 2015 -2022 HCL Technologies Limited, all rights reserved.
 *  Material published by HCL Technologies on these web pages/mobile
 *  app may not be reproduced without permission.
 */

import React, { useEffect, useMemo, useState } from 'react';
import { withTranslation } from 'react-i18next';
import BrightcoveClass from '../../../utils/brightcove';
import { getRandomId } from '../../../utils/utils';
import { Video as VidTransform } from '../../../data-transform/components/Video';

const Video = (props) => {
  const { renderQna, type, data } = props;
  const Brightcove = useMemo(() => new BrightcoveClass(), []);
  const [vidId] = useState(getRandomId());
  useEffect(() => {
    renderQna('bgItem');
  }, [data]);

  useEffect(() => {
    const transformData = VidTransform(data, true);
    let options = {
      loop: true,
      textTrackDisplay: false,
      autoplay: true,
    };
    if (type === 'bg-video') {
      options.controlBar = {
        fullscreenToggle: false,
        progressControl: false,
        audioTrackButton: false,
        subsCapsButton: false,
        playbackRateMenuButton: false,
        currentTimeDisplay: false,
        timeDivider: false,
        durationDisplay: false,
      };
      options.muted = true;
    }
    setTimeout(() => {
      Brightcove.brightCoveWebPlayer(
        'quiz-' + vidId,
        data.itemid_s,
        'quizComponent',
        transformData.fields,
        options,
        function () {
          console.log('creating BrightCove player');
        }
      );
    }, 200);
    return () => {
      Brightcove.closeVideo();
    };
  }, [Brightcove]);

  return (
    <div className={type === 'bg-video' ? 'question__background' : 'question__hero'}>
      <div className={`question__${type}`}>
        <div
          className="mu-item__player quiz-video-element"
          id={`quiz-${vidId}`}
          style={{ opacity: 1, width: '100%', height: '100%' }}
        />
      </div>
      {type === 'bg-video' && <div className="mu-item__gradient" />}
    </div>
  );
};
export default withTranslation()(Video);
